import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ThemeProvider, useTheme } from '@material-ui/core/styles';
const OverlayHostZIndexContext = /*#__PURE__*/ React.createContext(undefined);
export const useOverlayHostZIndex = ()=>React.useContext(OverlayHostZIndexContext);
/** The z-index a popup must paint at to clear the overlay hosting it — for a surface that portals to `<body>` and so cannot rely on DOM order. */ export function useOverlayPopupZIndex() {
    return useTheme().zIndex.modal;
}
// WHY: MUI portals popups at theme.zIndex.modal (1300) which sits below an order-climbing overlay, so raising zIndex.modal for the overlay's content subtree lifts every popup above its own host in one place — FullPageModal (IsInModal=false) included.
// WHY: the lift is relative to the host and stays inside the host's stride band, so a NEW overlay opened from one of those popups still out-stacks it — a global picker band (ANCR-3039's 100000) buried every later overlay.
// WHY: zIndex.tooltip must climb with modal — MUI's scale orders tooltip above modal, and raising modal alone buries a tooltip opened from inside a popup hosted by a modal.
export function OverlayPopupZIndex(param) {
    let { hostZIndex, children } = param;
    const outer = useTheme();
    const theme = React.useMemo(()=>_object_spread_props(_object_spread({}, outer), {
            zIndex: _object_spread_props(_object_spread({}, outer.zIndex), {
                modal: hostZIndex + 1,
                tooltip: hostZIndex + 2
            })
        }), [
        outer,
        hostZIndex
    ]);
    return /*#__PURE__*/ _jsx(OverlayHostZIndexContext.Provider, {
        value: hostZIndex,
        children: /*#__PURE__*/ _jsx(ThemeProvider, {
            theme: theme,
            children: children
        })
    });
}
